import { isSupportSession } from "@/utils/supportSession";
import { datadogRum } from "@datadog/browser-rum";
import { datadogLogs } from "@datadog/browser-logs";
import { reactPlugin } from "@datadog/browser-rum-react";

export function initDatadog() {
  if (import.meta.env.VITE_DATADOG_ENABLED !== "true") return;

  datadogLogs.init({
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
    site: import.meta.env.VITE_DATADOG_SITE,
    service: "ai-tutor",
    env: import.meta.env.VITE_DATADOG_ENV,
    version: import.meta.env.VITE_DATADOG_VERSION,
    forwardConsoleLogs: ["log", "info", "warn", "error"],
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  });

  datadogRum.init({
    applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
    site: import.meta.env.VITE_DATADOG_SITE,
    service: "ai-tutor",
    env: import.meta.env.VITE_DATADOG_ENV,
    version: import.meta.env.VITE_DATADOG_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: "mask-user-input",
    trackViewsManually: false,
    trackInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    // Both backends, or RUM would stop tracing the majority of API calls the
    // moment the routers moved to apps/web.
    allowedTracingUrls: [
      (url) => url.startsWith(import.meta.env.VITE_WEB_BASE_URL || "/"),
      (url) => url.startsWith(import.meta.env.VITE_BASE_URL || "/"),
    ],
    trackFrustrations: true,
  });
}

export const logErrorToDataDog = (error, errorInfo, { source }) => {
  if (
    import.meta.env.VITE_DATADOG_ENABLED === "true" &&
    import.meta.env.VITE_DATADOG_CLIENT_TOKEN
  ) {
    datadogRum.addError(error, {
      errorInfo,
      source: source || "react-error-boundary",
      componentStack: errorInfo?.componentStack,
    });
  }
};

export const setDatadogUser = (user) => {
  // A support session authenticates as the target, so identifying here
  // attributes the operator's whole session to that user. Guarded inside
  // the helper rather than at its call sites: there are four, and the one
  // that matters most is initialize() reading a cached user on reload --
  // which is why the marker is seeded from localStorage at module load.
  if (isSupportSession()) return;
  if (import.meta.env.VITE_DATADOG_ENABLED === "true") {
    datadogRum.setUser({
      id: String(user.id),
      name: user.name,
      email: user.email,
      role: user.role,
      username: user.username,
    });
  }
};

export const clearDatadogUser = () => {
  if (import.meta.env.VITE_DATADOG_ENABLED === "true") {
    datadogRum.clearUser();
  }
};
